import React from "react";
import { useAuth } from "@/hooks/useAuth.ts";
import { LogOut, UserRoundX } from "lucide-react";

export function UserMenu() {
  const { user, loading } = useAuth();

  if (loading || !user?.authenticated) {
    return (
      <div className="flex items-center gap-2 w-full font-bold p-2">
        <div className="bg-base-200 w-8 h-8 rounded-full p-2">
          <UserRoundX className="w-4 h-4 text-black" />
        </div>
        Nicht eingeloggt
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 w-full font-bold p-2">
      <img className="w-8 rounded-full" src={user.picture} alt="Profilbild" />
      <div className="grow">{user.name}</div>
      <form action="/api/logout" method="post">
        <button
          type="submit"
          role="menuitem"
          className="text-red-800 hover:text-red-600 cursor-pointer"
        >
          <LogOut className="w-6" aria-label="Logout" />
        </button>
      </form>
    </div>
  );
}
